import { AssignedModalProps, EmployeeNodeModel } from '../../models';

export const ASSIGNED_MODAL_PROPS_EMPTY: AssignedModalProps = {
    startDate: '',
    endDate: '',
    employee: {} as EmployeeNodeModel[],
};
